import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../../styles/globals';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  padding-top: 1rem;
  ${({ theme }) => `
  border-top: 1px solid ${theme.colors.neutral.primary[40]};
  `};
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  min-height: 60px;
  display: flex;
  margin-top: 1rem;

  ${({ theme }) => `
    gap: ${theme.layout.spacing.mikro};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
  `};
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  &:first-child {
    margin-left: 1rem;
    justify-content: left;
  }
`;

export const Text = styled(BodyRegularS)`
  line-break: anywhere;

  ${({ theme }) => `
  color: ${theme.colors.neutral.primary[80]};
`}
`;

export const Title = styled(BodyBoldS)`
  margin-left: 2rem;
  font-size: 16px;
  ${({ theme }) => `
  color: ${theme.colors.neutral.primary[80]};
`}
`;
